module.exports = __webpack_public_path__ + "media/images/sp/special_reports/separator_white-f3277f0e50456c17b774fa2d14ffa80f.jpg";